import { render, staticRenderFns } from "./IsApprove.vue?vue&type=template&id=4a93bbbc&scoped=true&"
import script from "./IsApprove.vue?vue&type=script&lang=js&"
export * from "./IsApprove.vue?vue&type=script&lang=js&"
import style0 from "./IsApprove.vue?vue&type=style&index=0&id=4a93bbbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a93bbbc",
  null
  
)

export default component.exports